<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div cdkDragHandle class="flex justify-between items-baseline pr-4">
    <h2 mat-dialog-title>eSOA Requirements</h2>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <span>
      <p>The Scope of Appointment cannot be emailed to the lead/beneficiary until the following required information is added to the lead record.
        <a class="linked-td" (click)="openUserProfile()">Click Here</a> to update lead details with the information listed below.
      </p>
      <p class="my-2">Missing eSignature Scope of Appointment Requirements:</p>
    </span>
    <ul>
      @if (leadMissingReq.fname) {
        <li>Lead's First Name</li>
      }
      @if (leadMissingReq.lname) {
        <li>Lead's Last Name</li>
      }
      @if (leadMissingReq.dob) {
        <li>Lead's DOB</li>
      }
      @if (leadMissingReq.email) {
        <li>Lead's Email</li>
      }
      @if (leadMissingReq.phone) {
        <li>Lead's Default Phone Number</li>
      }
      @if (leadMissingReq.address1) {
        <li>Lead's Default Street Address</li>
      }
      @if (leadMissingReq.city) {
        <li>Lead's Default City</li>
      }
      @if (leadMissingReq.state) {
        <li>Lead's Default State</li>
      }
      @if (leadMissingReq.zip) {
        <li>Lead's Default Zip Code</li>
      }
      @if (leadMissingReq.medicare_parta_date) {
        <li>Lead's Medicare Part A Effective Date</li>
      }
      @if (leadMissingReq.medicare_partb_date) {
        <li>Lead's Medicare Part B Effective Date</li>
      }
    </ul>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Close</button>
    <button mat-flat-button color="primary" (click)="openUserProfile()">Update Lead</button>
  </div>
</div>
